import React from 'react'

const COLOR_CLASSES = {
  blue: {
    focus: 'focus:border-blue-500 focus:ring-2 focus:ring-blue-200',
    button: 'border-blue-300 text-blue-600 hover:bg-blue-50',
  },
  purple: {
    focus: 'focus:border-purple-500 focus:ring-2 focus:ring-purple-200',
    button: 'border-purple-300 text-purple-600 hover:bg-purple-50',
  },
  indigo: {
    focus: 'focus:border-indigo-500 focus:ring-2 focus:ring-indigo-200',
    button: 'border-indigo-300 text-indigo-600 hover:bg-indigo-50',
  },
  emerald: {
    focus: 'focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200',
    button: 'border-emerald-300 text-emerald-600 hover:bg-emerald-50',
  },
  red: {
    focus: 'focus:border-red-500 focus:ring-2 focus:ring-red-200',
    button: 'border-red-300 text-red-600 hover:bg-red-50',
  },
}

export default function FilterSelect({ label, value, options, onChange, colorScheme = 'indigo' }) {
  const colors = COLOR_CLASSES[colorScheme] || COLOR_CLASSES.indigo
  return (
    <label className="flex flex-col gap-1 text-sm">
      <span className="font-medium text-gray-700">{label}</span>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className={`rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm outline-none transition ${colors.focus}`}
      >
        {options.map((opt) => {
          const optValue = typeof opt === 'string' ? opt : opt.value
          const optLabel = typeof opt === 'string' ? opt : opt.label
          return <option key={optValue} value={optValue}>{optLabel}</option>
        })}
      </select>
    </label>
  )
}
